import moment from "moment";

export function downloadCSVFromBlob(blob: Blob, filename?: string) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download =
        filename ||
        moment().local().format("YYYY-MM-DD_hh-mm-ss") + "-export.csv";

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    URL.revokeObjectURL(url);
}
